/**
 * @module Teams
 */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import TeamCards from './components/TeamCards';
import { STRINGS } from './helpers/strings';

/**
 * Represents the view for Teams page for Life.Church Careers.
 *
 * @param {object} props - The component props object.
 * @param {Array<Team>} props.teams - Array of team data objects.
 *
 * @returns {React.ReactElement} The Teams component.
 */
export default function Teams({ teams }) {
  return (
    <div className="teams" data-testid="lc-teams">
      <div className="py-bit_more_relaxed mb-bit_more_relaxed">
        <h1 className="text-title text-center">{STRINGS.roles.findFit}</h1>
        <h2 className="text-subhead text-center">
          {STRINGS.roles.browseRoles}
        </h2>
      </div>
      <TeamCards teams={teams} />
    </div>
  );
}
